'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mobile', {
      url: '/mobile',
      template: '<mobile></mobile>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/mobile/mobile.routes.js